"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CultureInfo_enAU_1 = require("./cultureinfo/CultureInfo_enAU");
var CultureInfo_enUK_1 = require("./cultureinfo/CultureInfo_enUK");
var Culture = (function () {
    function Culture(language, country) {
        this._cultureInfo = Culture.findCultureInfo(language, country);
    }
    Culture.getDefault = function () {
        if (Culture._default === undefined) {
            Culture._default = Culture.enAU();
        }
        return Culture._default;
    };
    Culture.setDefault = function (culture) {
        Culture._default = culture;
    };
    Culture.registerCulture = function (language, country, cultureInfo) {
        if (Culture.poolEmpty()) {
            Culture._cultureInfoPool = new Object();
        }
        Culture._cultureInfoPool[language + country] = new cultureInfo();
    };
    Culture.enUK = function () {
        if (Culture._enUK === undefined) {
            Culture._enUK = new Culture(Culture.ENGLISH, Culture.UK);
        }
        return Culture._enUK;
    };
    Culture.enAU = function () {
        if (Culture._enAU === undefined) {
            Culture._enAU = new Culture(Culture.ENGLISH, Culture.AUSTRALIA);
        }
        return Culture._enAU;
    };
    Culture.populatePoolFromPackage = function () {
        Culture.registerCulture(Culture.ENGLISH, Culture.AU, CultureInfo_enAU_1.CultureInfoEnAU);
        Culture.registerCulture(Culture.ENGLISH, Culture.UK, CultureInfo_enUK_1.CultureInfoEnUK);
    };
    Culture.findCultureInfo = function (language, country) {
        if (Culture.poolEmpty()) {
            Culture.populatePoolFromPackage();
        }
        var cultureInfo = Culture._cultureInfoPool[language + country];
        if (cultureInfo === undefined) {
            throw new Error("Culture not found.");
        }
        else {
            return cultureInfo;
        }
    };
    Culture.poolSize = function () {
        var count = 0;
        var prop;
        for (prop in Culture._cultureInfoPool) {
            if (Culture._cultureInfoPool.hasOwnProperty(prop)) {
                count++;
            }
        }
        return count;
    };
    Culture.poolEmpty = function () {
        return Culture._cultureInfoPool === undefined || Culture.poolSize() === 0;
    };
    Culture.prototype.financialYear = function (date) {
        return this._cultureInfo.financialYear(date);
    };
    Culture.prototype.getLanguage = function () {
        return this._cultureInfo.getLanguage();
    };
    Culture.prototype.getCountry = function () {
        return this._cultureInfo.getCountry();
    };
    Culture.UK = "UK";
    Culture.AUSTRALIA = "AU";
    Culture.AU = "AU";
    Culture.ENGLISH = "en";
    return Culture;
}());
exports.Culture = Culture;
//# sourceMappingURL=Culture.js.map